export const SetPageTitle = (version: string) => {
  document.title = `League of Legends - Patch ${version}`;
};
